$(function() {
  $(".wishlist").each(function(i, bookmark) {
    $(bookmark).on("click", function(e) {
      e.stopPropagation();
      e.preventDefault();
      if (!LOGGED_IN) {
        $("#loginAlertModal").modal("show");
        return;
      }

      let id = $(this).data("id");
      let saved = $(this).data("saved");

      $.ajax({
        method: saved ? "DELETE" : "POST",
        url: `${location.origin}/api/v1/ads/${id}/fav/${
          saved ? "remove" : "save"
        }`,
      }).done(function(res) {
        saved = !saved;
        $(bookmark).attr("data-saved", saved);
        if ($(bookmark).is(".bookmark")) {
          $(bookmark).attr(
            "src",
            saved ? $(bookmark).data("icon") : $(bookmark).data("icon-outlined")
          );
        } else {
          $(bookmark)
            .find("img")
            .attr("src", saved ? wishlist.saved.icon : wishlist.unsaved.icon)
            .data("saved", saved);
          $(bookmark)
            .find("span")
            .html(saved ? wishlist.saved.text : wishlist.unsaved.text);
        }
        $(bookmark).data("saved", saved);
      });
    });
  });
});



// WEBPACK FOOTER //
// ./app/webpacker/src/js/wishlist.js